export const scalarRuleset = `extends: spectral:oas
rules: {}`
